<template>
  <section class="section">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-half">
          <form class="box">
            <h1 class="title is-5" v-t="'title'" />
            <users-form :user.sync="user" :errors="errors" class="has-margin-bottom-md" />
            <button
              type="submit"
              class="button is-danger"
              @click.prevent="save($event)">
              <b-icon icon="save" />
              <span v-t="'save'" />
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import API from '@/api'
import UsersForm from '@/components/UsersForm'

export default {
  name: 'MyAccount',
  components: { UsersForm },
  data () {
    return {
      user: {},
      errors: {}
    }
  },
  mounted () {
    this.user = this.$auth.user()
  },
  methods: {
    save (event) {
      const btn = event.currentTarget

      btn.classList.add('is-loading')

      API.users.update(this.user.id, this.user, this.saveCallback(btn), this.errorCallback)
    },
    saveCallback (btn) {
      this.$snotify.success(this.$t('alert_message'), this.$t('alert_title'))
      btn.classList.remove('is-loading')
    },
    errorCallback (err) {
      if (err.response) {
        this.errors = err.response.data.errors
      }
    }
  },
  metaInfo () {
    return { title: this.$t('title') }
  }
}
</script>

<i18n>
{
  "en-US": {
    "title": "My Account",
    "save": "Save profile",
    "save": "Save profile",
    "alert_title": "Success",
    "alert_message": "Data successfully updated!"
  },
  "pt-BR": {
    "title": "Minha Conta",
    "save": "Salvar dados",
    "alert_title": "Sucesso",
    "alert_message": "Dados atualizados com sucesso!"
  }
}
</i18n>
